export default __webpack_public_path__ + "static/image_activities-c5f57ca55b094659c37a728ca069fe8f.jpg";